import { getGrowthFeatureDefaults } from "./growth-feature-defaults-copy";

export type GrowthFeatureAiContentToolId = "title" | "meta" | "brief";

export type GrowthFeatureAiContentToolCopy = {
  id: GrowthFeatureAiContentToolId;
  label: string;
  prompt: string;
};

export type GrowthFeatureAiContentDemoCopy = {
  tools: GrowthFeatureAiContentToolCopy[];
};

export type GrowthFeatureAiContentCardCopy = {
  title: string;
  description: string;
  badge: string;
  demo: GrowthFeatureAiContentDemoCopy;
};

export const DEFAULT_GROWTH_FEATURE_AI_CONTENT_COPY: GrowthFeatureAiContentCardCopy = getGrowthFeatureDefaults("en").aiContent as GrowthFeatureAiContentCardCopy;
